import './meeting-details-modal.scss';
import JoinButton from '../join-button/join-button';
import { formatFriendlyDate } from '../../utils/dateUtils';
import type { CalendarItem } from '../calendar/calendar.types';

type MeetingDetailsModalProps = {
  meeting: CalendarItem;
  onClose: () => void;
};

const MeetingDetailsModal = ({ meeting, onClose }: MeetingDetailsModalProps) => (
  <div
    className="meeting-calendar__modal"
    role="dialog"
    aria-modal="true"
    aria-label="Meeting details"
    onClick={onClose}
  >
    <div className="meeting-calendar__modal-content" onClick={(event) => event.stopPropagation()}>
      <button
        type="button"
        className="meeting-calendar__modal-close"
        onClick={onClose}
        aria-label="Close meeting details"
      >
        ×
      </button>

      <div className="meeting-calendar__modal-body">
        <div className="meeting-calendar__modal-header">
          <h3>{meeting.title}</h3>
        </div>

        <div className="meeting-calendar__modal-details">
          <span>{formatFriendlyDate(meeting.date)}</span>
          <span>{meeting.time}</span>
          <span>{meeting.location}</span>
        </div>

        <p>{meeting.description}</p>

        <JoinButton link={meeting.link} />
      </div>
    </div>
  </div>
);

export default MeetingDetailsModal;
